import { differenceInMinutes, format } from 'date-fns';
import {
	BlockReleaseApiResponse,
	BlockReleaseDecorated
} from '@data/blockReleases/types/BlockRelease.types';
import { sortObjectsByField } from '@utilities/sortObjectsByField/sortObjectsByField';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';
import {
	roundAndParseReleaseDateTime
} from '@components/BlockRelease/utils/roundAndParseReleaseDateTime/roundAndParseReleaseDateTime';

export const findNextRelease = (
	releases: BlockReleaseApiResponse[]
): BlockReleaseDecorated => {
	const filteredReleases: BlockReleaseApiResponse[] = releases.filter((release) => {
		const hasReleasableState = [
			BlockReleaseState.RECOMMENDED_RELEASE,
			BlockReleaseState.FLIP_RECOMMENDATION,
			BlockReleaseState.NOT_RELEASED
		].includes(release.state);

		const hasPendingOriginal =
			(release.originalReleases ?? []).some(
				(originalRelease) =>
					originalRelease.state === BlockReleaseState.PENDING_RELEASE
			);

		return hasReleasableState && !hasPendingOriginal;
	});

	const decoratedReleases = filteredReleases.map((release: BlockReleaseApiResponse) => {
		const roundedStartTime = roundAndParseReleaseDateTime(release.startDateTime);
		const roundedEndTime = roundAndParseReleaseDateTime(release.endDateTime);

		const duration = differenceInMinutes(roundedEndTime, roundedStartTime);

		return {
			...release,
			duration,
			roundedStartTime: format(roundedStartTime, 'yyyy-MM-dd HH:mm'),
			roundedEndTime: format(roundedEndTime, 'yyyy-MM-dd HH:mm'),
		};
	});

	const sortedDecoratedReleases = decoratedReleases.sort((a, b) => {
		return (
			sortObjectsByField('roundedStartTime')(a, b) ||
			sortObjectsByField('duration', true)(a, b) ||
			sortObjectsByField('blockStartTime')(a, b) ||
			sortObjectsByField('slotName')(a, b)
		);
	});

	return sortedDecoratedReleases[0];
};
